let handler = null;

export const registerUnauthorizedHandler = (fn) => {
  handler = fn;
};

export const clearUnauthorizedHandler = () => {
  handler = null;
};

export const emitUnauthorized = () => {
  try {
    if (handler) handler();
  } catch (e) {
    // swallow handler errors
  }
};

export default {
  registerUnauthorizedHandler,
  clearUnauthorizedHandler,
  emitUnauthorized,
};
